<template lang="html">
  <div>


    <div class="row">
      <div class="col-md-12" v-show="teams.length == 0" style="margin-top:29vh; margin-bottom:30vh">
        <div class="loader_page"></div>
      </div>
      <div class="col-md-12" v-show="!(teams.length == 0)">
        <div class="row label-zl">
          <div class="start">
            <img src="../assets/label.png" class>
          </div>
          <div class="md10">
            <h5>Lista załóg ONLINE</h5>
          </div>
          <div class="end">
            <img src="../assets/end.png" class>
          </div>
        </div>
        <div class="card mb-2">
          <div class="card-body">
            <div>
              <div class="row">
                <div class="col-md-11">
                  <input type="text" v-model="search" class="form-control input-sm" style="height:calc(1.7rem + 2px);font-size:13px" placeholder="Wpisz nazwę drużyny którą szukasz...">
                </div>

              </div>

            </div>

            <hr>
            <div class="overflow">

              <table class="tbl-header">
                <thead>
                  <th>Miniatura</th>
                  <th>Nazwa</th>
                  <th>Pojazd</th>
                  <th>Aktualizacja</th>
                  <th>Operacje</th>
                </thead>
                <tbody>
                  <tr :key="index" v-for="(item,index) in paginatedData">
                    <td>
                      <clazy-load v-bind:src="url + item.team.icon" class="card-img-top">
                        <img v-bind:src="url + item.team.icon" class="card-img-top" style="max-width:30px">
                        <div class="preloader" slot="placeholder">
                          <div class="loader"></div>
                        </div>
                      </clazy-load>
                    </td>
                    <td>
                      {{item.team.name}}
                    </td>
                    <td>
                      <div>{{item.vehicle.mark}} {{item.vehicle.model}}</div>
                    </td>
                    <td v-if="item.updatedAt != undefined">
                      {{item.updatedAt | formatDateCorrect}}
                    </td>
                    <td v-if="item.updatedAt == undefined">
                      Brak danych
                    </td>
                    <td>
                      <router-link :to="{path: '/teams/' + item.team._id, params: {team: item}}" v-b-tooltip.hover title="Pokaż szczegóły">
                        <span class="ti ti-search"></span>
                      </router-link>
                      <a v-b-tooltip.hover title="Pokaż aktualną lokalizację" @click="show('gps',item.gps.coordinates)" style="color: #539aff">
                        <span class="ti ti-map" style="margin-left:10px"> </span>
                      </a>

                    </td>
                  </tr>
                </tbody>

              </table>
            </div>

            <div class="row" v-show="!(teams.length == 0)" style="margin-top:10px">
              <div class="col-md-9">
                <p style="margin-bottom:0">Ilość: {{teams.length}}</p>
              </div>

              <div class="col-md-3">
                <ul class="pagination pagination-sm" v-show="search == ''" style="margin-bottom:0">
                  <li class="page-item" @click="prevPage" :disabled="pageNumber == 0"><a class="page-link" href="#">Wróć</a></li>
                  <li class="page-item" v-show="pageNumber == 1" @click="pageNumber =0"><a class="page-link" href="#">1</a></li>

                  <li class="page-item" v-show="pageNumber > 1" @click="pageNumber-=1"><a class="page-link" href="#">{{pageNumber}}</a></li>

                  <li class="page-item active"><a class="page-link" href="#">{{pageNumber + 1}}</a></li>
                  <li class="page-item" v-show="pageNumber != lastItem" @click="pageNumber+=1"><a class="page-link" href="#">{{pageNumber + 2}}</a></li>


                  <li class="page-item" @click="nextPage"><a class="page-link" href="#">Dalej</a></li>

                </ul>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>

    <modal name="gps">
      <div v-if="info == ''" style="text-align:center;padding-top:60px">
        <img src="../assets/alert.svg" alt="load_image">
        <h4 style="padding-top:20px">Brak danych koordynacyjnych!</h4>
      </div>
      <GmapMap v-if="info != ''" :center="{lat: info[1], lng: info[0]}" :zoom="14" map-type-id="terrain" style="width: 100%; height: 100%">
        <GmapMarker :position="{lat: info[1], lng: info[0]}" :clickable="true" :draggable="true" />
      </GmapMap>
    </modal>

  </div>


</template>

<script>
  import api from '../http/api.js'
  import config from '../config.json'
  export default {
    data() {
      return {
        teams: [],
        searchBox: true,
        url: config.url,
        pageNumber: 0,
        info: [],
        search: "",
        lastItem: "",
        secondLast: "",
        modalData: [],
        pos: {
          lat: 50.265401,
          lng: 19.027222
        }
      }
    },
    props: {
      listData: {
        type: Array,
        required: false
      },
      size: {
        type: Number,
        required: false,
        default: 10
      }
    },
    computed: {
      pageCount() {

        let l = this.teams.length,
          s = this.size;
        return Math.floor(l / s);
      },
      paginatedData() {
        var vm = this
        const start = this.pageNumber * this.size,
          end = start + this.size;

        vm.secondLast = (Math.round((this.teams.length / 10), 0) - 1)
        vm.lastItem = Math.round((this.teams.length / 10), 0)
        if (this.search == "") {
          return this.teams
            .slice(start, end);
        } else {
          return this.teams.filter(function(item) {
            if (item.team.name.toLowerCase().match(vm.search.toLowerCase()))
              return item
          })
        }
      }
    },
    methods: {
      viewSearch() {
        if (this.searchBox)
          this.searchBox = false
        else {
          this.search = ""
          this.searchBox = true
        }
      },
      show(el, data) {
        this.info = data
        switch (el) {
          case 'comments':
            this.$modal.show('comments');
            break;
          case 'gps':
            this.$modal.show('gps');
            break;
        }
      },
      hide(el) {
        switch (el) {
          case 'comments':
            this.$modal.hide('comments');
            break;
          case 'gps':
            this.$modal.hide('gps');
            break;
        }
      },
      nextPage() {
        this.pageNumber++;
      },
      prevPage() {
        this.pageNumber--;
      },
      getTeam() {
        var vm = this
        api.getGpsAction()
          .then(function(res) {
            vm.teams = res.data
          })
      }
    },
    mounted() {
      this.getTeam()
    }
  }
</script>

<style media="screen">

</style>
